import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { QCFlowTestBenchRequest, QCFlowTestBenchStatus } from '../models/qc-flow-test-bench';

/**
 * NK-462. The QC Flow test bench endpoints (SuperAdmin-only on the API). A run starts in the
 * background and is polled until it is done.
 */
@Injectable({
  providedIn: 'root'
})
export class QCFlowTestBenchService {
  baseUrl = environment.apiEndpoint + '/qcflowtestbench/';

  constructor(private http: HttpClient) { }

  Start(request: QCFlowTestBenchRequest): Observable<QCFlowTestBenchStatus> {
    return this.http.post<QCFlowTestBenchStatus>(this.baseUrl, request);
  }

  GetStatus(runId: string): Observable<QCFlowTestBenchStatus> {
    return this.http.get<QCFlowTestBenchStatus>(this.baseUrl + encodeURIComponent(runId));
  }
}
